import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Typography from 'carbon-react/lib/components/typography';
import Button from 'carbon-react/lib/components/button';

import { Integration } from '@futrli-sdk/app-store';

import * as styles from './integration-start.scss';
import { TechnicalIssuesCarbon } from '../technical-issues/technical-issues-carbon';

interface Props {
  activeIntegrationId?: string;
  error?: boolean;
  imageOverride?: string;
  connectTextOverride?: ReactElement;
  integration: Integration;
  onClick?: (integration: Integration) => Promise<void>;
}

export const IntegrationStartCarbon = ({
  activeIntegrationId,
  error,
  imageOverride,
  connectTextOverride,
  integration,
  onClick
}: Props) => {
  const busy = integration.id === activeIntegrationId;
  const disabled = typeof activeIntegrationId === 'string';
  const showError = error && busy;

  return (
    <>
      <div
        className={classNames(styles.container, { [styles.disabledContainer]: disabled })}
        onClick={() => onClick?.(integration)}
      >
        <img
          src={imageOverride || integration.image}
          alt={`Logo ${integration.name}`}
          style={{ width: 40, height: 40 }}
        />
        <Typography fontWeight="500" fontSize="18px" ml="16px" mb={0}>
          {integration.name}
        </Typography>
        <Button buttonType="primary" size="medium" ml="auto" p="8px 24px">
          {busy ? (
            <FormattedMessage id="common.connecting" defaultMessage="Connecting" />
          ) : (
            connectTextOverride || <FormattedMessage id="common.connect" defaultMessage="Connect" />
          )}
        </Button>
      </div>
      {showError && (
        <div className={styles.errorMessageWrapper}>
          <TechnicalIssuesCarbon />
        </div>
      )}
    </>
  );
};
